import { useState, useEffect } from "react";
import { locale } from "src/config/app-config";
import { getIsoLocale } from "src/utils/getIsoLocale";

let molliePromise: Promise<unknown> | undefined;
function useMollie(): { mollie: unknown | undefined } {
  const [mollie, setMollie] = useState<unknown>();
  const isoLocale = getIsoLocale(locale);

  useEffect(() => {
    if (!molliePromise) {
      molliePromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://js.mollie.com/v1/mollie.js";
        script.addEventListener("load", () => {
          resolve(
            window.Mollie(process.env.NEXT_PUBLIC_MOLLIE_PROFILE, {
              locale: isoLocale,
              testmode:
                process.env.NEXT_PUBLIC_MOLLIE_ENV === "test" ? true : false,
            })
          );
        });
        document.body.appendChild(script);
      });
    }

    void molliePromise?.then((mollie: any) => setMollie(mollie));
  }, [isoLocale]);

  return { mollie };
}

export { useMollie };
